import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.createActivity.loading;
export const selectErrorMessage = (state: RootState) =>
  state.createActivity.error;
export const createActivityDataResponse = (state: RootState) =>
  state.createActivity.createActivityResponse;
export const activityCreated = (state: RootState) => state.createActivity.saved;
